/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, select } from 'redux-saga/effects';
import { SubmissionError, change, untouch } from 'redux-form';
import { isCouponApplied } from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.selectors';
import {
  loadPersonalizedCoupons,
  fetchCoupons,
} from '@tcp/core/src/components/features/CnC/Checkout/container/CheckoutReview.saga';
import bagPageActions, {
  resetCartCache,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  getSetOrderConfirmationActn,
  getSetOrderProductDetails,
} from '@tcp/core/src/components/features/CnC/Confirmation/container/Confirmation.actions';
import constants from '@tcp/core/src/components/features/CnC/Checkout/organisms/BillingPaymentForm/container/CreditCard.constants';
import { getIsDisablePaysecureReset } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { trackFormError } from '@tcp/core/src/analytics/actions';
import logger from '@tcp/core/src/utils/loggerInstance';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  isTCP,
  isSNJ,
  isGymboree,
  isPJP,
  setSessionStorage,
  normalizeUSPhone,
} from '@tcp/core/src/utils';
import { CONTACT_FORM } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.constant';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import { addEditStoreDetailsApi } from '@tcp/core/src/services/abstractors/SFCC/addEditStoreDetails';
import InjectConfirmationDynamicStore from '@tcp/core/src/components/features/CnC/Confirmation/container/ConfirmationDynamicStore';
import { getLedgerSummaryData } from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import { SPC_BUTTON } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import injectCouponDynamicStore from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/CouponDynamicStore';
import {
  getUserEmail,
  getUserPhoneNumber,
  getUserLoggedInState,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import {
  updatePaymentOnOrder,
  addPaymentToOrder,
  getServerErrorMessage,
  saveOrUpdateBillingInfo,
} from '../../../../../services/abstractors/CnC/Checkout';
import {
  paySecureOperations,
  checkForPaySecure,
  addPaymentInstrument,
  getBillingAddress,
  getCardDetails,
} from './CheckoutBilling.saga.util';
import { resetAirmilesReducer } from '../../common/organism/AirmilesBanner/container/AirmilesBanner.actions';
import { validateAndSubmitEmailSignup } from './CheckoutExtended.saga.util';
import {
  resetCouponReducer,
  clearCouponTTL,
} from '../../common/organism/CouponAndPromos/container/Coupon.actions';
import verifyAddressData from '../../../../../services/abstractors/account/AddressVerification';
import selectors, { isGuest } from './Checkout.selector';
import CHECKOUT_ACTIONS, {
  getSetIsBillingVisitedActn,
  getSetCheckoutStage,
  resetPaySecure,
  setAfterPayInProgress,
  submitReviewSection,
  setApplePaymentInProgress,
  addCreditCardReCaptcha,
  getSetShippingValuesActn,
  setAfterPayPaymentProgress,
  getSetPickupValuesActn,
  setExpressAfterpayFlow,
} from './Checkout.action';
import { getGrandTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import utility from '../util/utility';
import { updateCreditCardSaga } from '../../../account/AddEditCreditCard/container/AddEditCreditCard.saga';
import CONSTANTS, { CHECKOUT_ROUTES, ORDER_TYPE } from '../Checkout.constants';
import { getAddressList } from '../../../account/AddressBook/container/AddressBook.saga';
import { getCardList } from '../../../account/Payment/container/Payment.saga';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import { getFormattedError } from '../../../../../utils/errorMessage.util';
import CreditCardSelector from '../organisms/BillingPaymentForm/container/CreditCard.selectors';
import ADDRESS_VERIFICATION_CONSTANTS from '../../../../common/organisms/AddressVerification/AddressVerification.constants';
import {
  setVerifyAddressSuccessData,
  resetAfterPayPayload,
} from '../../../../common/organisms/AddressVerification/container/AddressVerification.actions';
import { isCanada } from '../../../../../utils/utils';
import { processMutationNonCachedDataSaga } from '../../BagPage/container/BagPage.saga';
import {
  appleVenmoSubmitOrderFn,
  handleAfterpaychckout,
  updateShippingAddressMethodAndGiftOption,
  addPIOfflineToSFCC,
  addPaymentInstruction,
} from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import { getPaymentInstrumentErrorMapping } from '../../../account/AddEditCreditCard/container/AddEditCreditCard.selectors';
import SpcSelector from '../../SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  updateSectionState,
  setCvvVisibilityOnViewMode,
  toggleSPC,
  setSpcButtonLoader,
} from '../../SinglePageCheckout/container/SinglePageCheckout.actions';
import { addPerformanceMarksForSection } from '../../SinglePageCheckout/container/SinglePageCheckout.saga.util';
import { SUBMIT_ORDER_BUTTON_VISIBLE } from '../../../../../constants/rum.constants';
import AddressVerificationDynamicStore from '../../../../common/organisms/AddressVerification/container/AddressVerificationDynamicStore';

const {
  getIsPaymentDisabled,
  getBillingValues,
  getAddressByKey,
  isCardNotUpdated,
  getShippingDestinationValues,
  getDetailedCreditCardById,
  getBopisValues,
} = selectors;
const { getCreditCardType } = utility;

export function* updatePaymentInstruction(formData, cardDetailsInfo, isGuestUser, res) {
  let cardDetails;
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  if (formData.onFileCardId) {
    if (!cardDetailsInfo) {
      cardDetails = yield select(getDetailedCreditCardById, formData.onFileCardId);
    } else {
      cardDetails = cardDetailsInfo;
    }
    const grandTotal = yield select(getGrandTotal);
    const requestData = {
      onFileCardId: formData.onFileCardId,
      cardNumber: cardDetails.accountNo,
      billingAddressId: cardDetails.billingAddressId,
      cardType: cardDetails.ccBrand && cardDetails.ccBrand.toUpperCase(),
      cvv: formData.cvv,
      monthExpire: cardDetails.expMonth,
      yearExpire: cardDetails.expYear,
      orderGrandTotal: grandTotal,
      setAsDefault: formData.setAsDefault || cardDetails.defaultInd,
      saveToAccount: !isGuestUser, // it's already on the account? why is this needed?
      applyToOrder: true,
      recaptchaToken: formData.recaptchaToken,
    };
    // FIXME: we need to store the details of the selected card and selected
    // address book entry, but like this it is pretty ugly. needs major cleanup
    yield call(addPaymentToOrder, requestData, errorMappings);
    yield select(isCardNotUpdated, requestData.onFileCardId);
  } else {
    const cardType = getCreditCardType(formData);
    const checkoutDetails = yield select(getBillingValues);
    const editingCardType =
      checkoutDetails.billing && checkoutDetails.billing.cardNumber
        ? getCreditCardType(checkoutDetails.billing)
        : '';
    const grandTotal = yield select(getGrandTotal);
    const requestData = {
      cardNumber: formData.cardNumber,
      billingAddressId: res.addressId,
      cardType: cardType || editingCardType,
      cvv: formData.cvv,
      monthExpire: formData.expMonth,
      yearExpire: formData.expYear,
      orderGrandTotal: grandTotal,
      setAsDefault: formData.setAsDefault,
      saveToAccount: !isGuestUser && formData.saveToAccount,
      applyToOrder: true,
      recaptchaToken: formData.recaptchaToken,
    };
    let addOrEditPaymentToOrder = addPaymentToOrder;
    // if it's a new card (no '*' in it) then we still need to call the addPayment instead of updatePayment service
    if (
      checkoutDetails.paymentId &&
      formData.cardNumber &&
      formData.cardNumber.substr(0, 1) === '*'
    ) {
      requestData.paymentId = checkoutDetails.paymentId;
      addOrEditPaymentToOrder = updatePaymentOnOrder;
    }
    yield call(addOrEditPaymentToOrder, requestData, errorMappings);
  }
}

/**
 * @function updateVenmoPaymentInstruction
 * @description - Update payment instruction for venmo checkout
 * @param {object} venmoDetails
 */
export function* updateVenmoPaymentInstruction() {
  const { PAYMENT_METHOD_VENMO } = CONSTANTS;
  const grandTotal = yield select(getGrandTotal);
  const shippingDetails = yield select(getShippingDestinationValues);
  const isVenmoSaveSelected = yield select(selectors.isVenmoPaymentSaveSelected);
  const venmoData = yield select(selectors.getVenmoData);
  const { nonce: venmoNonce, deviceData: venmoDeviceData } = venmoData || {};
  const userName = yield select(selectors.getVenmoUserName);
  const billingAddressId = shippingDetails.onFileAddressId;
  const paymentMethod = PAYMENT_METHOD_VENMO && PAYMENT_METHOD_VENMO.toUpperCase();
  const requestData = {
    billingAddressId,
    cardType: paymentMethod,
    cc_brand: paymentMethod,
    cardNumber: userName || 'test-user', // Venmo User Id, for all the scenario's it will have user information from the venmo, for dev, added test-user
    isDefault: 'false',
    orderGrandTotal: grandTotal,
    applyToOrder: true,
    monthExpire: '',
    yearExpire: '',
    setAsDefault: false,
    saveToAccount: false,
    venmoDetails: {
      userId: userName || 'test-user',
      saveVenmoTokenIntoProfile: isVenmoSaveSelected,
      nonce: venmoNonce,
      venmoDeviceData,
    },
  };
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  yield call(addPaymentToOrder, requestData, errorMappings);
}

/**
 * @function updateAppleBillingInstruction
 * @description - Update billing instruction for apple checkout
 * @param {object} appleOrderSubmit
 */
export function* updateAppleBillingInstruction(payload) {
  const { PAYMENT_TYPE_APPLE } = CONSTANTS;
  const {
    appleOrderSubmit,
    paymentNonce,
    storeId,
    device_data,
    email,
    amount,
    orderId,
    addressId,
  } = payload;
  const header = {
    paymentType: PAYMENT_TYPE_APPLE,
    orderSubmit: appleOrderSubmit,
  };
  const requestData = {
    paymentNonce,
    storeId,
    device_data,
    email,
    amount: amount.toFixed(2).toString(),
    orderId: orderId && orderId.toString(),
    addressId: addressId && addressId.toString(),
  };
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  return yield call(saveOrUpdateBillingInfo, { requestData, header }, errorMappings);
}

export const formatPayloadForMallisa = (payload) => {
  const { addressLine1, addressLine2, zipCode, preferred, state, country, ...otherPayload } =
    payload;
  return {
    ...otherPayload,
    ...{
      address1: addressLine1,
      address2: addressLine2,
      postalCode: zipCode,
      stateCode: state,
      countryCode: country,
      preferred,
    },
  };
};

/**
 * @function checkoutWithAfterPay
 * @description - Update payment instruction for venmo checkout
 * @param {object} billingdetails
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* checkoutWithAfterPay({ payload }) {
  let response;
  const grandTotal = yield select(getGrandTotal);
  const shippingDetails = yield select(getShippingDestinationValues);
  const {
    cardNumber,
    monthExpire,
    yearExpire,
    cvv,
    cardType,
    reviewFormValues,
    addressId,
    singlePageCheckout,
    navigation,
    token,
    errorLabels,
    isExpressAfterPayPayment,
    isMallisaFailed,
    orderType,
  } = payload;

  const isNonEcom = orderType !== ORDER_TYPE.PURE_ECOM;
  const isCartTypePickup = isNonEcom && orderType !== 'ECOM_MIX';
  if (isExpressAfterPayPayment) {
    yield put(setAfterPayPaymentProgress(true));
  }
  const ledgerSummaryData = yield select(getLedgerSummaryData);
  const billingAddressId = shippingDetails?.onFileAddressId || addressId;
  const requestData = {
    billingAddressId,
    cardType,
    cc_brand: cardType,
    cardNumber,
    monthExpire,
    yearExpire,
    cvv,
    isDefault: 'false',
    orderGrandTotal: grandTotal,
    applyToOrder: true,
    setAsDefault: false,
    saveToAccount: false,
    afterpay: true,
  };
  const { address, emailAddress } = shippingDetails;
  let billingAddress = {};
  if (address && address.addressLine1) {
    billingAddress = { ...address, emailAddress };
  } else {
    const bopisdetails = yield select(getBopisValues);
    billingAddress = { ...bopisdetails };
  }
  try {
    let isVerifyAddressForAfterPay = isMallisaFailed;

    if (isExpressAfterPayPayment && !isVerifyAddressForAfterPay && !isCartTypePickup) {
      const userAddress = formatPayloadForMallisa(billingAddress);
      const { suggestedAddress, resultType, resultCodes } = yield call(
        verifyAddressData,
        userAddress
      );
      const { GENERIC_CODES, OPTIONAL_ADDRESS_LINE, NO_ACTION_CODES, INVALID_CODES } =
        ADDRESS_VERIFICATION_CONSTANTS.VERIFY_ERROR_CODES_MAPPING;
      const { GENERIC_ERROR_CODES } = ADDRESS_VERIFICATION_CONSTANTS.ADDRESS_FORM_ERROR_CODES;
      const isGenericError = GENERIC_CODES.some((code) => resultCodes.indexOf(code) !== -1);
      const showOptionalAddressLineError = resultCodes.includes(OPTIONAL_ADDRESS_LINE);
      const addressFormError = GENERIC_ERROR_CODES.some((code) => resultCodes.indexOf(code) !== -1);

      isVerifyAddressForAfterPay =
        NO_ACTION_CODES.find((code) => resultCodes.includes(code)) ||
        !INVALID_CODES.find((code) => resultCodes.includes(code));
      logger.info(
        'Afer Pay Malissa Results',
        isGenericError,
        showOptionalAddressLineError,
        addressFormError
      );
      if (!isVerifyAddressForAfterPay) {
        yield AddressVerificationDynamicStore();

        yield put(setLoaderState(false));
        yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
        yield put(bagPageActions.setAfterPayPopupOpen(false));
        const {
          subTotal = 0,
          shippingTotal = 0,
          giftServiceTotal = 0,
          giftCardsTotal = 0,
          couponsTotal = 0,
          savingsTotal = 0,
          calculatedEstimatedTax,
        } = ledgerSummaryData || {};
        const orderTotal = Math.abs(
          Number(
            subTotal +
              Number(calculatedEstimatedTax) +
              shippingTotal +
              giftServiceTotal -
              giftCardsTotal -
              couponsTotal -
              savingsTotal
          )
        ).toFixed(2);
        yield put(
          setVerifyAddressSuccessData({
            userAddress,
            suggestedAddress,
            resultType,
            resultCodes,
            afterpayPayload: { ...payload, isMallisaFailed: true, orderTotal },
          })
        );
        yield put(setExpressAfterpayFlow(true));
        utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
      }
    }

    if (!isExpressAfterPayPayment || isVerifyAddressForAfterPay || isCartTypePickup) {
      const errorMappings = yield select(BagPageSelectors.getErrorMapping);
      if (singlePageCheckout) {
        const cardDetails = {
          accountNo: cardNumber,
          expMonth: monthExpire,
          expYear: yearExpire,
          cvv,
          afterpay: true,
        };
        const otherErrors = yield select(getPaymentInstrumentErrorMapping);
        const allErrorMapping = { ...errorMappings, ...otherErrors };
        const isGuestUser = yield select(isGuest);
        const sessionId = yield call(paySecureOperations, false, cardDetails, billingAddress);
        response = yield call(
          addPaymentInstrument,
          billingAddress,
          sessionId,
          cardDetails,
          false,
          false,
          isGuestUser,
          allErrorMapping
        );
      } else {
        response = yield call(addPaymentToOrder, requestData, errorMappings);
      }
      if (response) {
        yield AddressVerificationDynamicStore();
        const submitReviewPayload = { formData: reviewFormValues };
        if (isVerifyAddressForAfterPay) {
          yield put(resetAfterPayPayload());
        }
        if (navigation) {
          submitReviewPayload.navigation = navigation;
        }
        if (token) {
          submitReviewPayload.token = token;
        }
        if (isExpressAfterPayPayment) {
          submitReviewPayload.isExpressAfterPayPayment = isExpressAfterPayPayment;
        }
        yield put(submitReviewSection(submitReviewPayload));
        if (isVerifyAddressForAfterPay) {
          yield put(resetAfterPayPayload());
        }
      } else if (!isExpressAfterPayPayment) {
        yield put(setLoaderState(false));
      }
      yield put(toggleSPC({ isSPC: true }));
      if (isExpressAfterPayPayment) {
        yield put(setSpcButtonLoader({ id: SPC_BUTTON.SUBMIT_ORDER, isLoading: false }));
      }
    }
  } catch (e) {
    if (!isExpressAfterPayPayment) {
      yield put(setLoaderState(false));
    }
    yield put(setAfterPayPaymentProgress(false));
    const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
    let billingError = getServerErrorMessage(e, errorsMapping);
    if (e && e.errorCodes === CONSTANTS.CUSTOM_OOS_ERROR_CODE) {
      billingError = e.errorMessages._error;
    } else if (e?.message === '_ERR_BILLING_ADDRESS_MISSING') {
      billingError = errorsMapping._ERR_BILLING_ADDRESS_MISSING;
      yield put(
        updateSectionState({
          id: 'paymentSection',
          section: { isExpanded: true, mode: 'SECTION_EDIT_MODE', isFormExpanded: true },
        })
      );
    }
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: isExpressAfterPayPayment ? errorLabels.AFTERPAY_CHECKOUT_ERROR : billingError,
        component: isExpressAfterPayPayment ? 'AfterPay' : 'PAGE',
      })
    );
    yield put(bagPageActions.setAfterPayPopupOpen(false));
    yield put(setSpcButtonLoader({ id: 'submitOrderBtn', isLoading: false }));
    if (isExpressAfterPayPayment) {
      yield put(setExpressAfterpayFlow(true));
      utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
    }
  } finally {
    const isDisablePaysecureReset = yield select(getIsDisablePaysecureReset);
    if (!isDisablePaysecureReset) {
      yield put(resetPaySecure());
    }
  }
}

export const formatShippingupdatedDTO = (data) => {
  return {
    shippingAddressDTO: {
      c_deliveryIndicator: '1',
      shippingAddress: {
        address1: data?.shipping?.line1,
        address2: data?.shipping?.line2,
        c_addressId: 'me',
        c_addressType: 'ShippingAndBilling',
        c_emailAddress: data?.consumer?.email,
        city: data?.shipping?.area1,
        countryCode: data?.shipping?.countryCode,
        firstName: data.consumer?.givenNames,
        lastName: data.consumer?.surname,
        phone: data?.shipping ? normalizeUSPhone(data.shipping.phoneNumber) : '',
        postalCode: data?.shipping?.postcode,
        stateCode: data?.shipping?.region,
      },
    },
    shippingMethod: { id: data.shippingOptionIdentifier },
  };
};

export const formatShippingData = (data, isLoggedIn, userEmail, userPhone) => {
  return {
    address: {
      addressId: 'me',
      addressLine1: data?.shipping?.line1,
      addressLine2: data?.shipping?.line2,
      city: data?.shipping?.area1,
      country: 'US',
      firstName: data.consumer?.givenNames,
      id: data.shippingOptionIdentifier,
      lastName: data.consumer?.surname,
      phone:
        userPhone || data?.shipping?.phoneNumber ? normalizeUSPhone(data.shipping.phoneNumber) : '',
      state: data?.shipping?.region,
      validationCode: null,
      zipCode: data?.shipping?.postcode,
      deliveryIndicator: null,
      emailAddress: isLoggedIn ? userEmail : data?.consumer?.email || data?.address?.email,
      addressType: 'ShippingAndBilling',
      sameAsShippingAddress: true,
    },
    emailAddress: data?.consumer?.email || data?.address?.email,
    phoneNumber: data?.shipping?.phoneNumber ? normalizeUSPhone(data.shipping.phoneNumber) : '',
    method: { shippingMethodId: data?.shippingOptionIdentifier },
  };
};

export const formatPickUpData = (data) => {
  return {
    emailAddress: data?.consumer?.email || data?.address?.email,
    firstName: data?.consumer?.givenNames,
    lastName: data?.consumer?.surname,
    phoneNumber: data?.shipping?.phoneNumber ? normalizeUSPhone(data.shipping.phoneNumber) : '',
  };
};

export const formatPickUpDTO = (data, basketId) => {
  return {
    email: data?.consumer?.email || data?.address?.email,
    firstName: data?.consumer?.givenNames,
    lastName: data?.consumer?.surname,
    phone: data?.shipping?.phoneNumber ? normalizeUSPhone(data.shipping.phoneNumber) : '',
    basketId,
  };
};

export function* checkoutWithExpressAfterPay({ payload }) {
  const { token, errorLabels, orderType, basketId } = payload;
  try {
    const afterpayCheckoutData = yield call(handleAfterpaychckout, token);
    const userEmail = yield select(getUserEmail);
    const userPhone = yield select(getUserPhoneNumber);
    const isLoggedIn = yield select(getUserLoggedInState) || false;
    if (afterpayCheckoutData?.response?.data?.shipping) {
      const afterpayCheckoutResData = afterpayCheckoutData.response.data;
      if (!isLoggedIn) {
        setSessionStorage({
          key: CONTACT_FORM,
          value: JSON.stringify({
            emailAddress: afterpayCheckoutResData?.consumer?.email,
            phoneNumber: normalizeUSPhone(afterpayCheckoutResData?.shipping?.phoneNumber),
          }),
        });
        if (orderType !== ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
          yield call(addEditStoreDetailsApi, formatPickUpDTO(afterpayCheckoutResData, basketId));
          yield put(getSetPickupValuesActn(formatPickUpDTO(afterpayCheckoutResData)));
        }
      }
      if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
        yield call(
          updateShippingAddressMethodAndGiftOption,
          formatShippingupdatedDTO(afterpayCheckoutResData)
        );
        yield put(
          getSetShippingValuesActn(
            formatShippingData(afterpayCheckoutResData, isLoggedIn, userEmail, userPhone)
          )
        );
      }
      yield call(checkoutWithAfterPay, { payload });
    }
  } catch (err) {
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: errorLabels.AFTERPAY_CHECKOUT_ERROR,
        component: 'AfterPay',
      })
    );
    utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
    yield put(setAfterPayPaymentProgress(false));
    yield put(bagPageActions.setAfterPayPopupOpen(false));
  }
}

export function* getAddressData(formData) {
  const existingAddress = yield select(getAddressByKey, formData.address.onFileAddressKey);
  const shippingDetails = yield select(getShippingDestinationValues);
  return existingAddress ? existingAddress.addressId : shippingDetails.onFileAddressId;
}

export function addressIdToString(addressId) {
  if (addressId) {
    return addressId.toString();
  }
  return null;
}

function* callOfflineOnAddPIFail(errorDetails, formData, allErrorMapping, billingAddress) {
  const { errorCodes } = errorDetails;
  if (errorCodes === '_TCP_PAYMENT_CC_TIMEOUT_ERROR') {
    const { isPLCC, saveToAccount, isDefault, cardType, recaptchaToken } = formData;
    const isMaskedCard = formData?.cardNumber?.startsWith('*');
    const cardDetails = yield call(getCardDetails, formData, isPLCC);
    cardDetails.saveToAccount = saveToAccount;
    cardDetails.isDefault = isDefault;
    cardDetails.cardType = cardType;
    yield call(addPIOfflineToSFCC, cardDetails, isMaskedCard);
    const basketResponse = yield call(
      addPaymentInstruction,
      billingAddress,
      null,
      allErrorMapping,
      recaptchaToken
    );
    const { billingMethodResp: respToProcess } = basketResponse;
    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess,
        isCheckoutFlow: true,
        ignoreCache: false,
      },
    });
    yield put(setCvvVisibilityOnViewMode(false));
    yield put(getSetIsBillingVisitedActn(true));
  } else {
    throw errorDetails;
  }
}

export function* submitBillingData(formData, address) {
  let fetchAddressBook = false;
  let sessionId;
  const {
    address: { sameAsShipping: isBillingAddressSameAsShipping },
    isPLCC,
    saveToAccount,
    isDefault,
    callFetchAddresses = true,
    cardType,
    recaptchaToken,
    differentCardSelectedFromList = false,
  } = formData;

  const billingAddress = yield call(getBillingAddress, formData, address);
  const isGuestUser = yield select(isGuest);
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  const otherErrors = yield select(getPaymentInstrumentErrorMapping);
  const allErrorMapping = { ...errorMappings, ...otherErrors };
  try {
    const isMaskedCard = formData.cardNumber.startsWith('*');
    const cardDetails = yield call(getCardDetails, formData, isPLCC);
    cardDetails.saveToAccount = saveToAccount;
    cardDetails.isDefault = isDefault;
    cardDetails.cardType = cardType;

    if (!isPLCC) {
      sessionId = yield call(checkForPaySecure, isMaskedCard, cardDetails, billingAddress);
    }

    if (!isBillingAddressSameAsShipping) {
      fetchAddressBook = true;
    }

    const res = yield call(
      addPaymentInstrument,
      billingAddress,
      sessionId,
      cardDetails,
      isMaskedCard,
      isPLCC,
      isGuestUser,
      allErrorMapping,
      recaptchaToken,
      true,
      differentCardSelectedFromList
    );
    const { billingMethodResp: respToProcess } = res;
    if (respToProcess?.c_couponMap) {
      yield injectCouponDynamicStore();
      yield put(clearCouponTTL());
    }
    addPerformanceMarksForSection(SUBMIT_ORDER_BUTTON_VISIBLE);

    yield call(processMutationNonCachedDataSaga, {
      payload: {
        respToProcess,
        isCheckoutFlow: true,
        ignoreCache: false,
      },
    });
    const shouldAskCvv = !!cardDetails.creditCardId && !cardDetails.cvv;
    yield put(setCvvVisibilityOnViewMode(shouldAskCvv));
    yield put(getSetIsBillingVisitedActn(true));
  } catch (err) {
    try {
      yield call(callOfflineOnAddPIFail, err, formData, allErrorMapping, billingAddress);
    } catch (error) {
      yield put(getSetIsBillingVisitedActn(false));
      throw error;
    }
  } finally {
    yield put(resetPaySecure());
  }
  if (fetchAddressBook && !isGuestUser && callFetchAddresses) {
    yield call(getAddressList);
  }
}

/**
 * @function submitVenmoBilling
 * @description - Redirect venmo payment from billing to review. This method is called from the Billing Page
 * @param {obejct} payload - venmo payload to submit billing and redirect to review page
 */
export function* submitVenmoBilling() {
  try {
    yield call(updateVenmoPaymentInstruction);
    yield put(getSetIsBillingVisitedActn(true)); // flag that billing section was visited by the user
  } catch (err) {
    yield put(getSetIsBillingVisitedActn(false)); // flag that billing section was visited by the user
    throw err;
  }
  utility.routeToPage(CHECKOUT_ROUTES.reviewPage);
}

/**
 * @function submitAppleBilling
 * @description - Redirect apple payment from billing to review. This method is called from the Billing Page
 * @param {obejct} payload - apple payload to submit billing and redirect to review page
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* submitAppleBilling({ payload }) {
  const {
    paymentNonce = null,
    paymentMethod = null,
    billingAddress = null,
    deviceData = null,
    saveToProfile = null,
    orderType = null,
  } = payload;
  const requestPayload = { paymentNonce, paymentMethod, billingAddress, deviceData, saveToProfile };
  try {
    yield InjectConfirmationDynamicStore();
    if (orderType === ORDER_TYPE.PURE_ECOM || orderType === ORDER_TYPE.ECOM_MIX) {
      const { resultCodes } = yield call(verifyAddressData, billingAddress);
      const { GENERIC_CODES, OPTIONAL_ADDRESS_LINE } =
        ADDRESS_VERIFICATION_CONSTANTS.VERIFY_ERROR_CODES_MAPPING;
      const { GENERIC_ERROR_CODES } = ADDRESS_VERIFICATION_CONSTANTS.ADDRESS_FORM_ERROR_CODES;
      const isGenericError = GENERIC_CODES.some((code) => resultCodes.indexOf(code) !== -1);
      const showOptionalAddressLineError = resultCodes.includes(OPTIONAL_ADDRESS_LINE);
      const addressFormError = GENERIC_ERROR_CODES.some((code) => resultCodes.indexOf(code) !== -1);
      logger.info(
        'Malissa Results',
        isGenericError,
        showOptionalAddressLineError,
        addressFormError
      );
    }
    const result = yield call(appleVenmoSubmitOrderFn, requestPayload);
    yield put(getSetIsBillingVisitedActn(true)); // flag that billing section was visited by the user
    if (result && (result.paymentInstruction || result.orderDetails)) {
      yield put(getSetOrderConfirmationActn(result));
      yield put(getSetCheckoutStage(CONSTANTS.CHECKOUT_STAGES.CONFIRMATION));
      utility.routeToPage(CHECKOUT_ROUTES.spcConfirmationPage);
      yield call(loadPersonalizedCoupons, result);
      const cartItems = yield select(BagPageSelectors.getOrderItems);
      const email = result.userDetails
        ? result.userDetails.emailAddress
        : result.shipping.emailAddress;
      const isCaSite = yield call(isCanada);
      const isGuestUser = yield select(isGuest);
      const { tcpProducts, gymProducts, snjProducts, pjpProducts } = yield select(
        BagPageSelectors.getProductsTypes
      );
      const isCouponAppliedInOrder = yield select(isCouponApplied);
      yield put(resetCartCache());
      yield put(getSetOrderProductDetails(cartItems));
      yield put(resetAirmilesReducer());
      yield injectCouponDynamicStore();
      yield put(resetCouponReducer());
      yield put(CHECKOUT_ACTIONS.resetCheckoutReducer());
      yield put(bagPageActions.resetCartReducer());
      yield call(fetchCoupons, isCouponAppliedInOrder);
      if (isGuestUser && !isCaSite && email) {
        yield call(
          validateAndSubmitEmailSignup,
          email,
          'us_guest_checkout',
          tcpProducts.length > 0 || isTCP(),
          gymProducts.length > 0 || isGymboree(),
          snjProducts.length > 0 || isSNJ(),
          pjpProducts?.length > 0 || isPJP()
        );
      }
    } else {
      utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
    }
  } catch (e) {
    setLoaderState(false);
    yield put(setApplePaymentInProgress(false));
    yield put(getSetIsBillingVisitedActn(false)); // flag that billing section was not visited by the user
    utility.routeToPage(CHECKOUT_ROUTES.singlePageCheckoutPage);
    yield put(resetCartCache());
    yield put(
      bagPageActions.getNonCachedCartData({
        disableLoading: true,
        isCheckoutFlow: true,
        ignoreCache: true,
      })
    );
    const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
    let billingError = getServerErrorMessage(e, errorsMapping);
    if (e && e.errorCodes === CONSTANTS.CUSTOM_OOS_ERROR_CODE) {
      billingError = e.errorMessages._error;
    }
    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({
        errorMessage: billingError,
        component: 'ApplePay',
      })
    );
    logger.error('Error in Apple Venmo submit', e);
  }
}

export default function* submitBilling(action = {}) {
  try {
    // TODO need to remove as it is temp fix to deliver review page for app
    const { payload: { navigation, ...formData } = {} } = action;
    formData.phoneNumber = formData.phoneNumber || '';
    const {
      addressId,
      firstName,
      lastName,
      addressLine1,
      addressLine2,
      state,
      city,
      country,
      zipCode,
    } = formData.address;
    const address = {
      addressId,
      addressLine1,
      addressLine2,
      city,
      country,
      firstName,
      lastName,
      state,
      zipCode,
    };
    yield put(getSetIsBillingVisitedActn(true)); // flag that billing section was visited by the user
    const isPaymentDisabled = yield select(getIsPaymentDisabled);
    if (!isPaymentDisabled) {
      yield call(submitBillingData, formData, address, navigation);
    }
    const isSPC = yield select(SpcSelector.checkIsSinglePageCheckout);
    if (!isSPC) {
      utility.routeToPage(CHECKOUT_ROUTES.reviewPage);
    }
  } catch (e) {
    logger.error('Error while submitting billing info', e);
    const { payload: { navigation, ...formData } = {}, propagateError } = action;

    const { address, cardNumber, expYear, expMonth, cardType, cvvCode, paymentMethodId } = formData;
    const list3ValAddressFields = Object.keys(address).reduce((result, key) => {
      const resultItem = result;
      resultItem[`address.${key}`] = address[key];
      return resultItem;
    }, {});
    const requiredList3Val = {
      paymentMethodId,
      cardNumber,
      expYear,
      expMonth,
      cardType,
      cvvCode,
      ...list3ValAddressFields,
    };

    yield put(trackFormError({ formName: 'checkoutBillingPayment', formData: requiredList3Val }));
    const ErrorForAdobe = 'form error:checkoutBilling';
    pushEventToAdobeAnalytics('form_error', ErrorForAdobe);
    const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
    let billingError = getServerErrorMessage(e, errorsMapping);
    if (e && e.errorCodes === CONSTANTS.CUSTOM_OOS_ERROR_CODE) {
      billingError = e.errorMessages._error;
    } else if (e?.message === '_ERR_BILLING_ADDRESS_MISSING') {
      billingError = errorsMapping._ERR_BILLING_ADDRESS_MISSING;
      yield put(
        updateSectionState({
          id: 'paymentSection',
          section: { isExpanded: true, mode: 'SECTION_EDIT_MODE', isFormExpanded: true },
        })
      );
    } else if (e?.message === '_ERR_INTERNATIONAL_BILLING_ADDRESS_PLCC') {
      billingError = errorsMapping._ERR_INTERNATIONAL_BILLING_ADDRESS_PLCC;
      yield put(
        updateSectionState({
          id: 'paymentSection',
          section: { isExpanded: true, mode: 'SECTION_EDIT_MODE', isFormExpanded: true },
        })
      );
    }

    yield put(
      CHECKOUT_ACTIONS.setServerErrorCheckout({ errorMessage: billingError, component: 'PAGE' })
    );
    const isGuestUser = yield select(isGuest);
    const formName = isGuestUser ? constants.GUEST_FORM_NAME : constants.FORM_NAME;
    yield put(change(formName, 'recaptchaToken', ''));
    yield put(untouch(formName, 'recaptaToken'));
    if (typeof window !== 'undefined') {
      window?.grecaptcha?.reset();
    }
    yield put(addCreditCardReCaptcha(e?.errorMessages?.errorParameters?.recaptcha));

    if (propagateError) {
      throw e;
    }
  }
}

export function* updateCardDetails({ payload: { formData, resolve, reject } }) {
  try {
    const isGuestUser = yield select(isGuest);
    const cardType = yield select(CreditCardSelector.getEditFormCardType);
    yield updateCreditCardSaga({ payload: { ...formData, cardType } }, true);
    if (!isGuestUser) {
      yield call(getCardList, { ignoreCache: true });
    }
    resolve();
  } catch (err) {
    const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
    const error = getServerErrorMessage(err, errorsMapping);
    reject(new SubmissionError({ _error: getFormattedError(new Error(error), errorsMapping) }));
  }
}

/**
 * @function submitAfterPayOnBilling
 * @description - Redirect venmo payment from billing to review. This method is called from the Billing Page
 * @param {obejct} payload - venmo payload to submit billing and redirect to review page
 */
export function* submitAfterPayOnBilling() {
  yield put(setAfterPayInProgress(true));
  utility.routeToPage(CHECKOUT_ROUTES.reviewPage);
}
